<template>
  <div>
    <div class="font-weight-bold mb-3">{{ $t('yourID') + cusID }}</div>
    <WCSpinner v-if="loading" position="window-center" size="xl" />
    <div class="wc-account-form">
      <WCProfileInfoSectionForm
        :me="me"
        @formChanged="processformUpdate"
        @formUpdateValid="formSave"
        v-if="hasProfileInfo"
      />
      <WCWorkInfoSectionForm
        :me="me"
        @formChanged="processformUpdate"
        @formUpdateValid="formSave"
        v-if="hasWorkInfo"
      />
      <WCOtherInfoSectionForm
        :me="me"
        @formChanged="processformUpdate"
        @formUpdateValid="formSave"
        v-if="hasOtherInfo"
      />
      <WCEmailInfoSectionForm
        :me="me"
        @formChanged="processformUpdate"
        @formUpdateValid="formSave"
        v-if="hasEmailInfo"
      />
      <WCPhoneInfoSectionForm
        :me="me"
        @formChanged="processformUpdate"
        @formUpdateValid="formSave"
        v-if="hasPhonesInfo"
      />
      <WCAddressInfoSectionForm
        :me="me"
        @formChanged="processformUpdate"
        @formUpdateValid="formSave"
        v-if="hasAddressesInfo"
      />
      <button
        class="btn btn-primary w-100 my-3 save-btn"
        @click="save(me)"
        :disabled="!isFormValid || loading"
      >
        {{ $t('save') }}
      </button>
    </div>
  </div>
</template>

<script>
import AccountSettingsMixin from '@/modules/user/mixins/AccountSettingsMixin';
import WCProfileInfoSectionForm from '@/modules/user/components/WCProfileInfoSectionForm/WCProfileInfoSectionForm.vue';
import WCWorkInfoSectionForm from '@/modules/user/components/WCWorkInfoSectionForm/WCWorkInfoSectionForm.vue';
import WCOtherInfoSectionForm from '@/modules/user/components/WCOtherInfoSectionForm/WCOtherInfoSectionForm.vue';
import WCEmailInfoSectionForm from '@/modules/user/components/WCEmailInfoSectionForm/WCEmailInfoSectionForm.vue';
import WCPhoneInfoSectionForm from '@/modules/user/components/WCPhoneInfoSectionForm/WCPhoneInfoSectionForm.vue';
import WCAddressInfoSectionForm from '@/modules/user/components/WCAddressInfoSectionForm/WCAddressInfoSectionForm.vue';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';

export default {
  name: 'WCAccountSettings',
  components: {
    WCProfileInfoSectionForm,
    WCWorkInfoSectionForm,
    WCEmailInfoSectionForm,
    WCOtherInfoSectionForm,
    WCPhoneInfoSectionForm,
    WCAddressInfoSectionForm,
    WCSpinner,
  },
  mixins: [AccountSettingsMixin], // Mixin for save, processUpdate, formSave, isFormValid
  props: {
    me: {
      type: Object,
    },
  },

  computed: {
    cusID() {
      return this.me.accountNumber;
    },
  },
  data() {
    return {
      loading: false,
      form: {
        prefix: this.me.prefix && this.me.prefix.value,
        firstName: this.me.firstName && this.me.firstName.value,
        middleName: this.me.middleName && this.me.middleName.value,
        lastName: this.me.lastName && this.me.lastName.value,
        suffix: this.me.suffix && this.me.suffix.value,
        nickname: this.me.nickName && this.me.nickName.value,
        birthDate: this.me.birthDate && this.me.birthDate.value,
        company: this.me.company && this.me.company.value,
        title: this.me.title && this.me.title.value,
        pf1: this.me.pf1 && this.me.pf1.value,
        pf2: this.me.pf2 && this.me.pf2.value,
        pf3: this.me.pf3 && this.me.pf3.value,
        pf4: this.me.pf4 && this.me.pf4.value,
        pf5: this.me.pf5 && this.me.pf5.value,
        pf6: this.me.pf6 && this.me.pf6.value,
        pf7: this.me.pf7 && this.me.pf7.value,
        pf8: this.me.pf8 && this.me.pf8.value,
        phones: this.me.phones,
        emails: this.me.emails,
        addresses: this.me.addresses,
      },
    };
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-account-form {
  width: 30rem;
}
</style>
